export function isEmpty(obj: object = {}): boolean {
  return Object.keys(obj)?.length === 0;
}

export function isNotEmpty(obj: object = {}): boolean {
  return !isEmpty(obj);
}
